/**
 * Set when the retailer dismisses the FD Marketplace Discount next session modal *
 */ export var FD_MARKETPLACE_DISCOUNT_MODAL_DISMISSED = 'FD_MARKETPLACE_DISCOUNT_MODAL_DISMISSED';
